import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import VariantBuilderPanelCollapse from "../variants/VariantBuilderPanelCollapse";

const ElementSettingsReviewsDesign = (props) => {
  const [contextData, builder, setContextData] = useContext(VariantContextData);
  const element = builder.selected().object;
  const variant = contextData.objects.variant;

  return (
    <React.Fragment>
      <VariantBuilderPanelCollapse name="Reviews" open={false}>
        <VariantBuilderSetting
          object={element}
          setting_name="[options][reviews-container-width]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Container Width"
          value={element.options["reviews-container-width"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][reviews-container-width-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Container Width"
          value={element.options["reviews-container-width-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][reviews-container-height]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Container Height"
          value={element.options["reviews-container-height"]}
          placeholder={variant.options["reviews-container-height"] || "auto"}
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
          tooltip="Applied as min-height; container grows taller if content requires it."
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][reviews-container-height-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Container Height"
          value={element.options["reviews-container-height-mobile"]}
          placeholder={
            variant.options["reviews-container-height-mobile"] ||
            variant.options["reviews-container-height"] ||
            "auto"
          }
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
          tooltip="Applied as min-height; container grows taller if content requires it."
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][reviews-content-vertical-spacing]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Content Vertical Spacing"
          value={element.options["reviews-content-vertical-spacing"]}
          placeholder={variant.options["reviews-content-vertical-spacing"] || "15"}
          min={0}
          max={200}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
          tooltip="Gap between each content type (rating, title, content, customer, date, source) inside a review."
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][reviews-content-vertical-spacing-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Content Vertical Spacing"
          value={element.options["reviews-content-vertical-spacing-mobile"]}
          placeholder={
            variant.options["reviews-content-vertical-spacing-mobile"] ||
            variant.options["reviews-content-vertical-spacing"] ||
            "15"
          }
          min={0}
          max={200}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
          tooltip="Gap between each content type (rating, title, content, customer, date, source) inside a review."
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][content-flow]"
          setting_type="dropdown"
          object_type="elements"
          object_id={element.id}
          value={element.options["content-flow"]}
          label="Content Flow"
          options={[
            { value: "", text: "Rows" },
            { value: "collage", text: "Collage", disabled: element.options['slider-enabled'] == 'true' },
          ]}
          condition={element.options["slider-enabled"] !== "true"}
        />

        <VariantBuilderSetting
          object={element}
          label="Inner Content Alignment"
          setting_name="[options][cf-inner-alignment]"
          setting_type="alignment"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["cf-inner-alignment"]
              ? element.options["cf-inner-alignment"]
              : "left"
          }
          device="desktop"
          show_reset={true}
          valueMappings={{
            left: "left",
            center: "center",
            right: "right",
          }}
        />

        <VariantBuilderSetting
          object={element}
          label="Inner Content Alignment"
          setting_name="[options][cf-inner-alignment-mobile]"
          setting_type="alignment"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["cf-inner-alignment-mobile"]
              ? element.options["cf-inner-alignment-mobile"]
              : ""
          }
          device="mobile"
          show_reset={true}
          valueMappings={{
            left: "left",
            center: "center",
            right: "right",
          }}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][slider-enabled]"
          setting_type="checkbox"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["slider-enabled"]
              ? element.options["slider-enabled"]
              : "true"
          }
          label="Slider Enabled"
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][slider-show-indicators]"
          setting_type="checkbox"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["slider-show-indicators"]
              ? element.options["slider-show-indicators"]
              : "true"
          }
          label="Slider Show Indicators"
          condition={
            !element.options["slider-enabled"] ||
            element.options["slider-enabled"] == "true"
          }
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][slider-show-arrows]"
          setting_type="checkbox"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["slider-show-arrows"]
              ? element.options["slider-show-arrows"]
              : "true"
          }
          label="Slider Show Arrows"
          condition={
            !element.options["slider-enabled"] ||
            element.options["slider-enabled"] == "true"
          }
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][reviews-per-row]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={element.options["reviews-per-row"]}
          placeholder={3}
          label={
            element.options["reviews-layout"] == "vertical"
              ? "Number of reviews per slide"
              : "Number of reviews per row"
          }
          min={1}
          max={10}
          step={1}
          condition={element.options["slider-enabled"] == "true"}
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][reviews-per-row-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={element.options["reviews-per-row-mobile"]}
          placeholder={1}
          label={
            element.options["reviews-layout"] == "vertical"
              ? "Number of reviews per slide"
              : "Number of reviews per row"
          }
          min={1}
          max={10}
          step={1}
          allow_empty={true}
          condition={element.options["slider-enabled"] == "true"}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][slider-style]"
          setting_type="dropdown"
          object_type="elements"
          object_id={element.id}
          value={element.options["slider-style"]}
          label="Slider Style"
          options={[
            { value: "", text: "Default" },
            { value: "inline", text: "Inline" },
          ]}
          condition={element.options["slider-enabled"] == "true"}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][reviews-arrow-size]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Arrow Size"
          value={
            element.options["reviews-arrow-size"]
              ? element.options["reviews-arrow-size"]
              : undefined
          }
          placeholder="12"
          min={1}
          max={40}
          range_step="1"
          device="desktop"
          allow_empty={true}
          condition={
            (!element.options["slider-enabled"] ||
              element.options["slider-enabled"] == "true") &&
            (!element.options["slider-show-arrows"] ||
              element.options["slider-show-arrows"] == "true")
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][reviews-arrow-size-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Arrow Size"
          value={
            element.options["reviews-arrow-size-mobile"]
              ? element.options["reviews-arrow-size-mobile"]
              : undefined
          }
          placeholder="12"
          min={1}
          max={40}
          range_step="1"
          device="mobile"
          allow_empty={true}
          condition={
            (!element.options["slider-enabled"] ||
              element.options["slider-enabled"] == "true") &&
            (!element.options["slider-show-arrows"] ||
              element.options["slider-show-arrows"] == "true")
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Background Color"
          setting_name="[options][reviews-background-color]"
          setting_type="color_v2"
          value={element.options["reviews-background-color"]}
          placeholder={variant.options["reviews-background-color"] || "#fff"}
          show_reset={true}
          gradient={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Border Style"
          setting_name="[options][reviews-border-style]"
          setting_type="border_style"
          value={element.options["reviews-border-style"]}
          placeholder={variant.options["reviews-border-style"] || "solid"}
          show_reset={true}
        />

        {element.options["reviews-border-style"] &&
          element.options["reviews-border-style"] !==
            "none" && (
            <div
              className="col-xs-12 some-vertical-space setting"
              style={{ marginBottom: "5px" }}
            >
              <div className="row">
                <div className="col-xs-12">
                <div className="mb-[5px] text-xl text-black dark:text-white">
                  Border Width
                </div>

                  {["left", "top", "bottom", "right"].map((side) => {
                    const settingName = `[options][reviews-border-width-${side}]`;
                    return (
                      <VariantBuilderSetting
                        key={settingName}
                        object={element}
                        object_type="elements"
                        object_id={element.id}
                        setting_name={settingName}
                        setting_type="number"
                        value={element.options[`reviews-border-width-${side}`]}
                        placeholder={
                          element.options["reviews-border-width"] || "1px"
                        }
                        col="3"
                        note={window.capitalizeFirstLetter(side)}
                        classNames="spacing-inputs"
                        min={0}
                        allow_empty={true}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Border Color"
          setting_name="[options][reviews-border-color]"
          setting_type="color_v2"
          placeholder="#000"
          value={
            element.options["reviews-border-color"]
              ? element.options["reviews-border-color"]
              : undefined
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Border Rounding"
          setting_name="[options][reviews-border-rounding]"
          setting_type="border_radius"
          value={
            element.options["reviews-border-rounding"]
              ? element.options["reviews-border-rounding"]
              : "cf-not-rounded"
          }
          condition={
            element.options["reviews-border-style"] !==
            "none"
          }
          valueMappings={{
            none: "cf-not-rounded",
            some: "cf-slightly-rounded",
            full: "cf-fully-rounded",
            custom: "custom",
          }}
        />

        <div className="col-xs-12">
          {["top-left", "top-right", "bottom-right", "bottom-left"].map(
            (side) => {
              const settingName = `[options][reviews-border-rounding-${side}]`;
              return (
                <VariantBuilderSetting
                  key={settingName}
                  object={element}
                  object_type="elements"
                  object_id={element.id}
                  setting_name={settingName}
                  setting_type="number"
                  value={
                    _.isNil(
                      element.options[`reviews-border-rounding-${side}`]
                    ) == false
                      ? element.options[
                          `reviews-border-rounding-${side}`
                        ]
                      : undefined
                  }
                  condition={
                    element.options[
                      "reviews-border-rounding"
                    ] == "custom"
                  }
                  min={0}
                  note={capitalizeFirstLetter(side).replace("-", " ")}
                  col="3"
                  placeholder="0px"
                  classNames="spacing-inputs"
                />
              );
            }
          )}
        </div>
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Rating" open={false}>
        <VariantBuilderSetting
          object={element}
          label="Rating Star Color"
          setting_name="[options][rating-star-color]"
          setting_type="color_v2"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["rating-star-color"]
              ? element.options["rating-star-color"]
              : undefined
          }
          placeholder={
            variant.options["rating-star-color"]
              ? variant.options["rating-star-color"]
              : "#EFAB40"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Rating Star Size"
          setting_name="[options][rating-star-size]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["rating-star-size"]
              ? element.options["rating-star-size"]
              : undefined
          }
          placeholder={
            variant.options["rating-star-size"]
              ? variant.options["rating-star-size"]
              : "14"
          }
          allow_empty={true}
          min={0}
          max={100}
          range_step={1}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Rating Star Size"
          setting_name="[options][rating-star-size-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["rating-star-size-mobile"]
              ? element.options["rating-star-size-mobile"]
              : undefined
          }
          placeholder={
            variant.options["rating-star-size-mobile"]
              ? variant.options["rating-star-size-mobile"]
              : "14"
          }
          allow_empty={true}
          min={0}
          max={100}
          range_step={1}
          device="mobile"
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Title" open={false}>
        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Title Font`}
          setting_name={`[options][title-font-family]`}
          setting_type="select"
          value={element.options[`title-font-family`]}
          placeholder={
            variant.options[`reviews-title-font-family`] ||
            variant.options[`h3-font-family`]
          }
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          setting_name={`[options][title-font-weight]`}
          setting_type="font_weight"
          label="Weight"
          value={element.options[`title-font-weight`]}
          placeholder={
            variant.options[`reviews-title-font-weight`] ||
            variant.options[`h3-font-weight`] ||
            "700"
          }
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Title Font size`}
          setting_name={`[options][title-font-size]`}
          setting_type="range"
          value={element.options[`title-font-size`]}
          placeholder={
            variant.options[`reviews-title-font-size`] ||
            variant.options[`h3-font-size`] ||
            "16"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Title Font size`}
          setting_name={`[options][title-font-size-mobile]`}
          setting_type="range"
          value={element.options[`title-font-size-mobile`]}
          placeholder={
            variant.options[`reviews-title-font-size-mobile`] ||
            variant.options[`reviews-title-font-size`] ||
            variant.options[`h3-font-size-mobile`] ||
            variant.options[`h3-font-size`] ||
            "16"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Title Font line height`}
          setting_name={`[options][title-font-line-height]`}
          setting_type="range"
          value={element.options[`title-font-line-height`]}
          placeholder={
            variant.options[`reviews-title-font-line-height`] ||
            variant.options[`h3-font-line-height`] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Title Font line height`}
          setting_name={`[options][title-font-line-height-mobile]`}
          setting_type="range"
          value={element.options[`title-font-line-height-mobile`]}
          placeholder={
            variant.options[`reviews-title-font-line-height-mobile`] ||
            variant.options[`reviews-title-font-line-height`] ||
            variant.options[`h3-font-line-height-mobile`] ||
            variant.options[`h3-font-line-height`] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Title Font color`}
          setting_name={`[options][title-font-color]`}
          setting_type="color_v2"
          value={element.options[`title-font-color`]}
          placeholder={
            variant.options[`reviews-title-font-color`] ||
            variant.options[`h3-font-color`] ||
            "#000"
          }
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Content" open={false}>
        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Content Font`}
          setting_name={`[options][content-font-family]`}
          setting_type="select"
          value={element.options[`content-font-family`]}
          placeholder={
            variant.options[`reviews-content-font-family`] ||
            variant.options[`p-font-family`]
          }
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          setting_name={`[options][content-font-weight]`}
          setting_type="font_weight"
          label="Weight"
          value={element.options[`content-font-weight`]}
          placeholder={
            variant.options[`reviews-content-font-weight`] ||
            variant.options[`p-font-weight`]
          }
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Content Font size`}
          setting_name={`[options][content-font-size]`}
          setting_type="range"
          value={element.options[`content-font-size`]}
          placeholder={
            variant.options[`reviews-content-font-size`] ||
            variant.options[`p-font-size`] ||
            "14"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Content Font size`}
          setting_name={`[options][content-font-size-mobile]`}
          setting_type="range"
          value={element.options[`content-font-size-mobile`]}
          placeholder={
            variant.options[`reviews-content-font-size-mobile`] ||
            variant.options[`reviews-content-font-size`] ||
            variant.options[`p-font-size-mobile`] ||
            variant.options[`p-font-size`] ||
            "14"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Content Font line height`}
          setting_name={`[options][content-font-line-height]`}
          setting_type="range"
          value={element.options[`content-font-line-height`]}
          placeholder={
            variant.options[`reviews-content-font-line-height`] ||
            variant.options[`p-font-line-height`] ||
            "25"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Content Font line height`}
          setting_name={`[options][content-font-line-height-mobile]`}
          setting_type="range"
          value={element.options[`content-font-line-height-mobile`]}
          placeholder={
            variant.options[`reviews-content-font-line-height-mobile`] ||
            variant.options[`reviews-content-font-line-height`] ||
            variant.options[`p-font-line-height-mobile`] ||
            variant.options[`p-font-line-height`] ||
            "25"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Content Font color`}
          setting_name={`[options][content-font-color]`}
          setting_type="color_v2"
          value={element.options[`content-font-color`]}
          placeholder={
            variant.options[`reviews-content-font-color`] ||
            variant.options[`p-font-color`] ||
            "#696969"
          }
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Customer Name" open={false}>
        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Customer Name Font`}
          setting_name={`[options][customer-profile-name-font-family]`}
          setting_type="select"
          value={element.options[`customer-profile-name-font-family`]}
          placeholder={
            variant.options[`reviews-customer-profile-name-font-family`] ||
            variant.options[`p-font-family`]
          }
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          setting_name={`[options][customer-profile-name-font-weight]`}
          setting_type="font_weight"
          label="Weight"
          value={element.options[`customer-profile-name-font-weight`]}
          placeholder={
            variant.options[`reviews-customer-profile-name-font-weight`] ||
            variant.options[`p-font-weight`]
          }
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Customer Name Font size`}
          setting_name={`[options][customer-profile-name-font-size]`}
          setting_type="range"
          value={element.options[`customer-profile-name-font-size`]}
          placeholder={
            variant.options[`reviews-customer-profile-name-font-size`] ||
            variant.options[`p-font-size`] ||
            "14"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Customer Name Font size`}
          setting_name={`[options][customer-profile-name-font-size-mobile]`}
          setting_type="range"
          value={element.options[`customer-profile-name-font-size-mobile`]}
          placeholder={
            variant.options[`reviews-customer-profile-name-font-size-mobile`] ||
            variant.options[`reviews-customer-profile-name-font-size`] ||
            variant.options[`p-font-size-mobile`] ||
            variant.options[`p-font-size`] ||
            "14"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Customer Name Font line height`}
          setting_name={`[options][customer-profile-name-font-line-height]`}
          setting_type="range"
          value={element.options[`customer-profile-name-font-line-height`]}
          placeholder={
            variant.options[`reviews-customer-profile-name-font-line-height`] ||
            variant.options[`p-font-line-height`] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Customer Name Font line height`}
          setting_name={`[options][customer-profile-name-font-line-height-mobile]`}
          setting_type="range"
          value={element.options[`customer-profile-name-font-line-height-mobile`]}
          placeholder={
            variant.options[`reviews-customer-profile-name-font-line-height-mobile`] ||
            variant.options[`reviews-customer-profile-name-font-line-height`] ||
            variant.options[`p-font-line-height-mobile`] ||
            variant.options[`p-font-line-height`] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Customer Name Font color`}
          setting_name={`[options][customer-profile-name-font-color]`}
          setting_type="color_v2"
          value={element.options[`customer-profile-name-font-color`]}
          placeholder={
            variant.options[`reviews-customer-profile-name-font-color`] ||
            variant.options[`p-font-color`] ||
            "#000"
          }
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Customer Title" open={false}>
        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Customer Title Font`}
          setting_name={`[options][customer-profile-title-font-family]`}
          setting_type="select"
          value={element.options[`customer-profile-title-font-family`]}
          placeholder={
            variant.options[`reviews-customer-profile-title-font-family`] ||
            variant.options[`p-font-family`]
          }
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          setting_name={`[options][customer-profile-title-font-weight]`}
          setting_type="font_weight"
          label="Weight"
          value={element.options[`customer-profile-title-font-weight`]}
          placeholder={
            variant.options[`reviews-customer-profile-title-font-weight`] ||
            variant.options[`p-font-weight`]
          }
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Customer Title Font size`}
          setting_name={`[options][customer-profile-title-font-size]`}
          setting_type="range"
          value={element.options[`customer-profile-title-font-size`]}
          placeholder={
            variant.options[`reviews-customer-profile-title-font-size`] ||
            variant.options[`p-font-size`] ||
            "12"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Customer Title Font size`}
          setting_name={`[options][customer-profile-title-font-size-mobile]`}
          setting_type="range"
          value={element.options[`customer-profile-title-font-size-mobile`]}
          placeholder={
            variant.options[`reviews-customer-profile-title-font-size-mobile`] ||
            variant.options[`reviews-customer-profile-title-font-size`] ||
            variant.options[`p-font-size-mobile`] ||
            variant.options[`p-font-size`] ||
            "12"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Customer Title Font line height`}
          setting_name={`[options][customer-profile-title-font-line-height]`}
          setting_type="range"
          value={element.options[`customer-profile-title-font-line-height`]}
          placeholder={
            variant.options[`reviews-customer-profile-title-font-line-height`] ||
            variant.options[`p-font-line-height`] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Customer Title Font line height`}
          setting_name={`[options][customer-profile-title-font-line-height-mobile]`}
          setting_type="range"
          value={element.options[`customer-profile-title-font-line-height-mobile`]}
          placeholder={
            variant.options[`reviews-customer-profile-title-font-line-height-mobile`] ||
            variant.options[`reviews-customer-profile-title-font-line-height`] ||
            variant.options[`p-font-line-height-mobile`] ||
            variant.options[`p-font-line-height`] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Customer Title Font color`}
          setting_name={`[options][customer-profile-title-font-color]`}
          setting_type="color_v2"
          value={element.options[`customer-profile-title-font-color`]}
          placeholder={
            variant.options[`reviews-customer-profile-title-font-color`] ||
            variant.options[`p-font-color`] ||
            "#696969"
          }
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Customer Avatar" open={false}>
        <VariantBuilderSetting
          object={element}
          setting_name="[options][customer-profile-avatar-width]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Image Width"
          value={element.options["customer-profile-avatar-width"]}
          placeholder="37"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][customer-profile-avatar-width-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Image Width"
          value={element.options["customer-profile-avatar-width-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][customer-profile-avatar-height]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Image Height"
          value={element.options["customer-profile-avatar-height"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][customer-profile-avatar-height-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Image Height"
          value={element.options["customer-profile-avatar-height-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_id={element.id}
          label="Image Radius"
          setting_name="[options][customer-profile-avatar-radius]"
          setting_type="border_radius"
          valueMappings={{
            none: "cf-not-rounded",
            some: "cf-slightly-rounded",
            full: "cf-fully-rounded",
            custom: "custom",
          }}
          object_type="elements"
          value={element.options["customer-profile-avatar-radius"]}
          show_reset={true}
        />

        {element.options["customer-profile-avatar-radius"] == "custom" && (
          <div className="col-xs-12">
            {["top-left", "top-right", "bottom-right", "bottom-left"].map(
              (side) => {
                const settingName = `[options][customer-profile-avatar-radius-${side}]`;
                return (
                  <VariantBuilderSetting
                    key={settingName}
                    object={element}
                    object_id={element.id}
                    setting_name={settingName}
                    setting_type="number"
                    object_type="elements"
                    value={
                      _.isNil(
                        element.options[
                          `customer-profile-avatar-radius-${side}`
                        ]
                      ) == false
                        ? element.options[
                            `customer-profile-avatar-radius-${side}`
                          ]
                        : undefined
                    }
                    min={0}
                    note={capitalizeFirstLetter(side).replace("-", " ")}
                    col="3"
                    placeholder={
                      variant.options[
                        `customer-profile-avatar-radius-${side}`
                      ]
                        ? variant.options[
                            `customer-profile-avatar-radius-${side}`
                          ]
                        : "0px"
                    }
                    classNames="spacing-inputs"
                  />
                );
              }
            )}
          </div>
        )}
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Brand Logo" open={false}>
        <VariantBuilderSetting
          object={element}
          setting_name="[options][brand-logo-width]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Image Width"
          value={element.options["brand-logo-width"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][brand-logo-width-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Image Width"
          value={element.options["brand-logo-width-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][brand-logo-height]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Image Height"
          value={element.options["brand-logo-height"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][brand-logo-height-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Image Height"
          value={element.options["brand-logo-height-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_id={element.id}
          label="Image Radius"
          setting_name="[options][brand-logo-radius]"
          setting_type="border_radius"
          valueMappings={{
            none: "cf-not-rounded",
            some: "cf-slightly-rounded",
            full: "cf-fully-rounded",
            custom: "custom",
          }}
          object_type="elements"
          value={element.options["brand-logo-radius"]}
          show_reset={true}
        />

        {element.options["brand-logo-radius"] == "custom" && (
          <div className="col-xs-12">
            {["top-left", "top-right", "bottom-right", "bottom-left"].map(
              (side) => {
                const settingName = `[options][brand-logo-radius-${side}]`;
                return (
                  <VariantBuilderSetting
                    key={settingName}
                    object={element}
                    object_id={element.id}
                    setting_name={settingName}
                    setting_type="number"
                    object_type="elements"
                    value={
                      _.isNil(
                        element.options[
                          `brand-logo-radius-${side}`
                        ]
                      ) == false
                        ? element.options[
                            `brand-logo-radius-${side}`
                          ]
                        : undefined
                    }
                    min={0}
                    note={capitalizeFirstLetter(side).replace("-", " ")}
                    col="3"
                    placeholder={
                      variant.options[
                        `brand-logo-radius-${side}`
                      ]
                        ? variant.options[
                            `brand-logo-radius-${side}`
                          ]
                        : "0px"
                    }
                    classNames="spacing-inputs"
                  />
                );
              }
            )}
          </div>
        )}
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Video" open={false}>
        <VariantBuilderSetting
          object={element}
          setting_name="[options][video-width]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Video Width"
          value={element.options["video-width"]}
          placeholder={
            variant.options["reviews-video-width"] || "auto"
          }
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][video-width-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Video Width"
          value={element.options["video-width-mobile"]}
          placeholder={
            variant.options["reviews-video-width-mobile"] || "auto"
          }
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][video-height]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Video Height"
          value={element.options["video-height"]}
          placeholder={
            variant.options["reviews-video-height"] || "auto"
          }
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][video-height-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Video Height"
          value={element.options["video-height-mobile"]}
          placeholder={
            variant.options["reviews-video-height-mobile"] || "auto"
          }
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <div className="col-xs-12 mt-4 mb-2 text-lg font-semibold text-black dark:text-white">
          Colors with Video Background
        </div>
        <div className="col-xs-12 mb-3 text-base text-slate-500 dark:text-slate-400">
          Applicable when video positioning is set to background. Defaults to white when unset.
        </div>

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Rating Star"
          setting_name="[options][reviews-video-bg-rating-color]"
          setting_type="color_v2"
          value={element.options["reviews-video-bg-rating-color"]}
          placeholder={
            variant.options["reviews-video-bg-rating-color"] ||
            element.options["reviews-video-background-text-color"] ||
            variant.options["reviews-video-background-text-color"] ||
            "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Title"
          setting_name="[options][reviews-video-bg-title-color]"
          setting_type="color_v2"
          value={element.options["reviews-video-bg-title-color"]}
          placeholder={
            variant.options["reviews-video-bg-title-color"] ||
            element.options["reviews-video-background-text-color"] ||
            variant.options["reviews-video-background-text-color"] ||
            "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Content"
          setting_name="[options][reviews-video-bg-content-color]"
          setting_type="color_v2"
          value={element.options["reviews-video-bg-content-color"]}
          placeholder={
            variant.options["reviews-video-bg-content-color"] ||
            element.options["reviews-video-background-text-color"] ||
            variant.options["reviews-video-background-text-color"] ||
            "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Customer Name"
          setting_name="[options][reviews-video-bg-customer-name-color]"
          setting_type="color_v2"
          value={element.options["reviews-video-bg-customer-name-color"]}
          placeholder={
            variant.options["reviews-video-bg-customer-name-color"] ||
            element.options["reviews-video-background-text-color"] ||
            variant.options["reviews-video-background-text-color"] ||
            "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Customer Title"
          setting_name="[options][reviews-video-bg-customer-title-color]"
          setting_type="color_v2"
          value={element.options["reviews-video-bg-customer-title-color"]}
          placeholder={
            variant.options["reviews-video-bg-customer-title-color"] ||
            element.options["reviews-video-background-text-color"] ||
            variant.options["reviews-video-background-text-color"] ||
            "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Date"
          setting_name="[options][reviews-video-bg-date-color]"
          setting_type="color_v2"
          value={element.options["reviews-video-bg-date-color"]}
          placeholder={
            variant.options["reviews-video-bg-date-color"] ||
            element.options["reviews-video-background-text-color"] ||
            variant.options["reviews-video-background-text-color"] ||
            "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Source"
          setting_name="[options][reviews-video-bg-source-color]"
          setting_type="color_v2"
          value={element.options["reviews-video-bg-source-color"]}
          placeholder={
            variant.options["reviews-video-bg-source-color"] ||
            element.options["reviews-video-background-text-color"] ||
            variant.options["reviews-video-background-text-color"] ||
            "#fff"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Overlay Color"
          setting_name="[options][reviews-video-overlay-color]"
          setting_type="color_v2"
          tooltip="Applicable when video positioning is set to background"
          value={
            element.options["reviews-video-overlay-color"]
              ? element.options["reviews-video-overlay-color"]
              : undefined
          }
          gradient={true}
          placeholder={
            variant.options["reviews-video-overlay-color"] || "#000"
          }
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Date" open={false}>
        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Date Format"
          setting_name={`[options][date-format]`}
          setting_type="dropdown"
          value={element.options[`date-format`]}
          placeholder={variant.options[`reviews-date-format`] || "YYYY-MM-DD"}
          options={[
            { value: "YYYY/MM/DD", text: "2024/06/27 (YYYY/MM/DD)" },
            { value: "MM/DD/YYYY", text: "06/27/2024 (MM/DD/YYYY)" },
            { value: "DD/MM/YYYY", text: "27/06/2024 (DD/MM/YYYY)" },
            { value: "MMMM DD, YYYY", text: "June 27, 2024 (MMMM DD, YYYY)" },
            { value: "DD MMMM YYYY", text: "27 June 2024 (DD MMMM YYYY)" },
          ]}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Date Font`}
          setting_name={`[options][date-font-family]`}
          setting_type="select"
          value={element.options[`date-font-family`]}
          placeholder={
            variant.options[`reviews-date-font-family`] ||
            variant.options[`p-font-family`]
          }
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          setting_name={`[options][date-font-weight]`}
          setting_type="font_weight"
          label="Weight"
          value={element.options[`date-font-weight`]}
          placeholder={
            variant.options[`reviews-date-font-weight`] ||
            variant.options[`p-font-weight`]
          }
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Date Font size`}
          setting_name={`[options][date-font-size]`}
          setting_type="range"
          value={element.options[`date-font-size`]}
          placeholder={
            variant.options[`reviews-date-font-size`] ||
            variant.options[`p-font-size`] ||
            "14"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Date Font size`}
          setting_name={`[options][date-font-size-mobile]`}
          setting_type="range"
          value={element.options[`date-font-size-mobile`]}
          placeholder={
            variant.options[`reviews-date-font-size-mobile`] ||
            variant.options[`reviews-date-font-size`] ||
            variant.options[`p-font-size-mobile`] ||
            variant.options[`p-font-size`] ||
            "14"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Date Font line height`}
          setting_name={`[options][date-font-line-height]`}
          setting_type="range"
          value={element.options[`date-font-line-height`]}
          placeholder={
            variant.options[`reviews-date-font-line-height`] ||
            variant.options[`p-font-line-height`] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Date Font line height`}
          setting_name={`[options][date-font-line-height-mobile]`}
          setting_type="range"
          value={element.options[`date-font-line-height-mobile`]}
          placeholder={
            variant.options[`reviews-date-font-line-height-mobile`] ||
            variant.options[`reviews-date-font-line-height`] ||
            variant.options[`p-font-line-height-mobile`] ||
            variant.options[`p-font-line-height`] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Date Font color`}
          setting_name={`[options][date-font-color]`}
          setting_type="color_v2"
          value={element.options[`date-font-color`]}
          placeholder={
            variant.options[`reviews-date-font-color`] ||
            variant.options[`p-font-color`] ||
            "#696969"
          }
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Source" open={false}>
        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Reviews Source Font`}
          setting_name={`[options][source-font-family]`}
          setting_type="select"
          value={element.options[`source-font-family`]}
          placeholder={
            variant.options[`reviews-source-font-family`] ||
            variant.options[`p-font-family`]
          }
          option_groups={["System fonts", "Google fonts"]}
          options={[
            { value: "", text: "Default" },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          setting_name={`[options][source-font-weight]`}
          setting_type="font_weight"
          label="Weight"
          value={element.options[`source-font-weight`]}
          placeholder={
            variant.options[`reviews-source-font-weight`] ||
            variant.options[`p-font-weight`]
          }
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Reviews Source Font size`}
          setting_name={`[options][source-font-size]`}
          setting_type="range"
          value={element.options[`source-font-size`]}
          placeholder={
            variant.options[`reviews-source-font-size`] ||
            variant.options[`p-font-size`] ||
            "14"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Reviews Source Font size`}
          setting_name={`[options][source-font-size-mobile]`}
          setting_type="range"
          value={element.options[`source-font-size-mobile`]}
          placeholder={
            variant.options[`reviews-source-font-size-mobile`] ||
            variant.options[`reviews-source-font-size`] ||
            variant.options[`p-font-size-mobile`] ||
            variant.options[`p-font-size`] ||
            "14"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Reviews Source Font line height`}
          setting_name={`[options][source-font-line-height]`}
          setting_type="range"
          value={element.options[`source-font-line-height`]}
          placeholder={
            variant.options[`reviews-source-font-line-height`] ||
            variant.options[`p-font-line-height`] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Reviews Source Font line height`}
          setting_name={`[options][source-font-line-height-mobile]`}
          setting_type="range"
          value={element.options[`source-font-line-height-mobile`]}
          placeholder={
            variant.options[`reviews-source-font-line-height-mobile`] ||
            variant.options[`reviews-source-font-line-height`] ||
            variant.options[`p-font-line-height-mobile`] ||
            variant.options[`p-font-line-height`] ||
            "20"
          }
          min={0}
          max={200}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label={`Reviews Source Font color`}
          setting_name={`[options][source-font-color]`}
          setting_type="color_v2"
          value={element.options[`source-font-color`]}
          placeholder={
            variant.options[`reviews-source-font-color`] ||
            variant.options[`p-font-color`] ||
            "#696969"
          }
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>
    </React.Fragment>
  );
};

export default ElementSettingsReviewsDesign;
